/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QuestionnaireDto } from '../../models/questionnaire-dto';

export interface QuestionnaireGetQuestionnaireToPlay$Plain$Params {
  insurerQuestionnaireId?: number;
  profileQuestionnaireId?: number;
  languageCode?: string;
}

export function questionnaireGetQuestionnaireToPlay$Plain(http: HttpClient, rootUrl: string, params?: QuestionnaireGetQuestionnaireToPlay$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireDto>> {
  const rb = new RequestBuilder(rootUrl, questionnaireGetQuestionnaireToPlay$Plain.PATH, 'get');
  if (params) {
    rb.query('insurerQuestionnaireId', params.insurerQuestionnaireId, {});
    rb.query('profileQuestionnaireId', params.profileQuestionnaireId, {});
    rb.query('languageCode', params.languageCode, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<QuestionnaireDto>;
    })
  );
}

questionnaireGetQuestionnaireToPlay$Plain.PATH = '/v1/Questionnaire/GetQuestionnaireToPlay';
